import pageStore from "./page_store.js";

export default class RootStore {
  pageStore = new pageStore();
}
